import { t } from '@framework/i18n';

/**
 * Funzione che restituisce le label per la verifica
 * TODO Verificare quali sono i valori di tipoVerifica
 */
export function getVerificationLabels(tipoVerifica: string) {
  switch (tipoVerifica) {
    case 'verifica-mail-dichiarante':
      return {
        title: t('verification-labels.verifica-email', 'Verifica Email'),
        subTitle: t(
          'verification-labels.click-sul-pulsante-per-completare-la-verifica',
          `Per completare la verifica dell'email fare click sul pulsante`,
        ),
        buttonText: t(
          'verification-labels.verifica-email',
          'Verifica Email',
        ),
      };

    default:
      return {
        title: t('verification-labels.verifica', 'Verifica'),
        subTitle: t(
          'verification-labels.click-sul-pulsante-per-completare-l-verifica',
          `Per completare la verifica fare click sul pulsante`,
        ),
        buttonText: t('verification-labels.verifica', 'Verifica'),
      };
  }
}
